import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { translations } from "./translations";

const STORAGE_KEY = "yemenLang";

/* Default value keeps <Navbar/> (and any other consumer) safe to render even
   when it is not wrapped in a provider — the language dropdown is hidden unless
   `enabled` is true, and t() falls back to the English source string. */
const LanguageContext = createContext({
   lang: "en",
   dir: "ltr",
   enabled: false,
   setLang: () => {},
   t: (str) => str
});

export const useLanguage = () => useContext(LanguageContext);

const readInitialLang = () => {
   try {
      return localStorage.getItem(STORAGE_KEY) === "ar" ? "ar" : "en";
   } catch (e) {
      return "en";
   }
};

export const LanguageProvider = ({ children }) => {
   const [lang, setLangState] = useState(readInitialLang);

   const setLang = useCallback((next) => {
      const value = next === "ar" ? "ar" : "en";
      setLangState(value);
      try {
         localStorage.setItem(STORAGE_KEY, value);
      } catch (e) {
         /* localStorage unavailable — keep in-memory state only */
      }
   }, []);

   const t = useCallback(
      (str) => (lang === "ar" ? translations[str] || str : str),
      [lang]
   );

   const value = useMemo(
      () => ({
         lang,
         dir: lang === "ar" ? "rtl" : "ltr",
         enabled: true,
         setLang,
         t
      }),
      [lang, setLang, t]
   );

   return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export default LanguageContext;
